var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-toggle',{attrs:{"disabled":_vm.disabled,"height":_vm.height,"width":_vm.width,"checkedText":_vm.$t(_vm.checkedText),"uncheckedText":_vm.$t(_vm.uncheckedText),"checkedBg":_vm.checkedBg,"uncheckedBg":_vm.uncheckedBg,"value":_vm.switchValue},on:{"click":function($event){_vm.switchValue = !_vm.switchValue}}})
}
var staticRenderFns = []

export { render, staticRenderFns }